import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from './LanguageContext';
export function AboutSection() {
  const {
    t
  } = useLanguage();
  return <section className="w-full py-24 md:py-32 bg-[var(--warm-cream)]" data-id="element-18">
      <div className="max-w-6xl mx-auto px-6 md:px-12" data-id="element-19">
        {/* Title centered above on mobile, hidden on desktop where it's in the right column */}
        <div className="flex md:hidden items-center justify-center gap-3 mb-10 whitespace-nowrap" data-id="element-20">
          <div className="w-6 h-[1px] bg-[#D4AF37]" data-id="element-21"></div>
          <h2 className="font-serif text-lg tracking-[0.2em] uppercase text-[#C9956A]" data-id="element-22">
            {t('about_title')}
          </h2>
          <div className="w-6 h-[1px] bg-[#D4AF37]" data-id="element-23"></div>
        </div>

        <div className="flex flex-col md:flex-row items-center gap-12 lg:gap-24" data-id="element-24">
          {/* Left Column: Photo */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="w-full md:w-1/2 relative" data-id="element-25">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl aspect-[3/4] max-w-md mx-auto" data-id="element-26">
              <img src="https://cdn.magicpatterns.com/uploads/2jTX2Pt18NYdXH3ayFecxe/foto_de_la_dueNa.png" alt="Iara Oliver" className="w-full h-full object-cover" data-id="element-27" />
              <div className="absolute inset-0 border border-[#D4AF37]/30 rounded-2xl m-4 pointer-events-none" data-id="element-28"></div>
            </div>
            {/* Decorative element behind image */}
            <div className="absolute -bottom-6 -right-6 w-32 h-32 border border-[#D4AF37]/20 rounded-full -z-10" data-id="element-29"></div>
            <div className="absolute -top-6 -left-6 w-24 h-24 border border-[#D4AF37]/20 rounded-full -z-10" data-id="element-30"></div>
          </motion.div>

          {/* Right Column: Bio */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          ease: 'easeOut',
          delay: 0.2
        }} className="w-full md:w-1/2 flex flex-col justify-center" data-id="element-31">
            <div className="hidden md:flex items-center gap-4 mb-6" data-id="element-32">
              <div className="w-12 h-[1px] bg-[#D4AF37]" data-id="element-33"></div>
              <h2 className="font-serif text-sm tracking-[0.3em] uppercase text-[#C9956A]" data-id="element-34">
                {t('about_title')}
              </h2>
            </div>

            <blockquote className="relative pl-6 border-l-2 border-[#D4AF37] mb-10" data-id="element-35">
              <p className="font-serif italic text-2xl md:text-3xl text-[#2C1810] leading-relaxed" data-id="element-36">
                {t('about_quote')}
              </p>
            </blockquote>

            <div className="space-y-6 text-[#5C3D2E] font-light leading-relaxed" data-id="element-37">
              <p data-id="element-38">{t('about_p1')}</p>
              <p data-id="element-39">
                {t('about_p2_1')}
                <span className="font-medium" data-id="element-40">{t('about_p2_2')}</span>
              </p>
              <p data-id="element-41">{t('about_p3')}</p>
              <p data-id="element-42">{t('about_p4')}</p>
            </div>
          </motion.div>
        </div>

        {/* Centered closing statement */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} className="mt-16 text-center max-w-2xl mx-auto" data-id="element-43">
          <div className="w-16 h-[1px] bg-[#D4AF37]/40 mx-auto mb-8" data-id="element-44"></div>
          <p className="font-serif text-2xl md:text-3xl text-[#2C1810] leading-relaxed" data-id="element-45">
            {t('about_close')}
          </p>
          <div className="w-16 h-[1px] bg-[#D4AF37]/40 mx-auto mt-8" data-id="element-46"></div>
        </motion.div>
      </div>
    </section>;
}